import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import HomePage from "@/pages/HomePage";
import ClaimsPage from "@/pages/ClaimsPage";
import InstructionsPage from "@/pages/InstructionsPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

function PackerCookieSaver() {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const packer = searchParams.get("packer");
    if (packer) {
      document.cookie = `packer=${encodeURIComponent(packer)};path=/;max-age=${60 * 60 * 24 * 90}`;
    }
  }, [searchParams]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App page-container">
        <BrowserRouter>
          <PackerCookieSaver />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/claims" element={<ClaimsPage />} />
              <Route path="/instructions" element={<InstructionsPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
